module.exports = __webpack_public_path__ + "img/ai1.8ff6cd1c.png";